import { useEffect, useState } from 'react';

function getStorageValue<TValue>(
  key: string,
  validateValue: (value: any) => TValue | null,
  defaultValue: TValue,
) {
  const saved = localStorage.getItem(key);
  if (!saved) return defaultValue;

  const initial = JSON.parse(saved);
  return validateValue(initial) || defaultValue;
}

export const useLocalStorage = <TValue>(
  key: string,
  validateValue: (value: any) => TValue | null,
  defaultValue: TValue,
) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, validateValue, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue] as const;
};
